import { ImgHTMLAttributes } from "react";
import { cn } from "~/lib/utils";

export default function AppLogoIcon({
  src = "/light_mode_logo.png",
  className,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  return <img {...props} src={src} alt="Logo" className={cn("object-contain", className)} />;
}
